import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import { IStorage } from '../services/storage/storage.interface';
import * as actions from '../store/hydrator/rehydrate.actions';
import { StateHydrator } from '../store/hydrator/state-hydrator';
import * as fromResetActions from '../store/reset-state/reset.actions';

export class StateManagerFacade  {

    constructor(
        protected appFacade: VasAppFacade,
        protected storage: IStorage,
        protected store: Store<any>
    ) {

    }

    reset(): void {
        this.appFacade.store.dispatch(new fromResetActions.ResetAction());
    }

    rehydrate(): Observable<any> {

        const stateHydrator = new StateHydrator(this.storage, this.store);

        return Observable.fromPromise(stateHydrator.getState())
            .do(() => this.appFacade.store.dispatch(new actions.RehydrateSuccessAction()))
            .catch(error => {
                console.error('failed to hydrate state', error);
                this.appFacade.store.dispatch(new actions.RehydrateFailAction(error));
                return of(undefined);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/state-manager-facade.ts